import classNames from 'classnames'
import { useContext, useEffect, useState } from 'react'
import Subheader from '../../components/Subheader'
import Card from '../../components/Card'
import { ThemeContext } from '../../context/themeContext'
import { useSelector } from 'react-redux'
import Skeleton from 'react-loading-skeleton'
import TodoList from '../TodoList'
import { Link } from 'react-router-dom'
import CommonModal from '../../components/CommonModal'
import { ReactComponent as SpySearch } from './spy-search.svg'
import { ReactComponent as A2AFlips } from './a2a-flips.svg'
import { ReactComponent as PreisWecker } from './preis-wecker.svg'
import { ReactComponent as ScanWizard } from './scan-wizard.svg'

export default function Overview() {
  let { firstTimeLoad, setFirstTimeLoad } = useContext(ThemeContext)
  let homeDetails = useSelector((state) => state.auth.homeData)
  let [loading, setLoading] = useState(true)
  let [isOnboardingModalOpen, setIsOnboardingModalOpen] = useState(false)
  let [hasDismissedOnboarding, setHasDismissedOnboarding] = useState(false)
  let showOnboardingVideo = Boolean(homeDetails?.showOnboardingVideo)

  useEffect(() => {
    if (homeDetails?.status === "authorized" && firstTimeLoad) {
      setTimeout(() => {
        setFirstTimeLoad(false);
      }, 1000)
    }
  }, [homeDetails, firstTimeLoad])

  useEffect(() => {
    if (homeDetails?.status === "authorized") {
      setLoading(false)
    }
  }, [homeDetails])

  useEffect(() => {
    if (!showOnboardingVideo) {
      setIsOnboardingModalOpen(false)
      setHasDismissedOnboarding(false)
      return
    }
    if (!hasDismissedOnboarding) {
      setIsOnboardingModalOpen(true)
    }
  }, [showOnboardingVideo, hasDismissedOnboarding])

  let handleCloseOnboardingModal = () => {
    setIsOnboardingModalOpen(false)
    setHasDismissedOnboarding(true)
  }

  return (
    <>
      <section className="bg-background flex-1 flex flex-col">
      <Subheader date className="px-4 py-2 border-b-[1px] dark:border-b-white/10">
        Willkommen <em>{homeDetails?.name}</em>
        <span className="ml-1">👋</span>
      </Subheader>

      <div className='overflow-y-auto flex-1'>
        <div className='grid grid-cols-2 lg:grid-cols-4 xl:grid-cols-6 gap-6 p-4'>
          <div
            className='
              row-span-2
              col-span-2
              rounded-[26px] shadow-[0px_0px_4px_0px_#0000001A]
              bg-[linear-gradient(119.92deg,#3D83FF_-3.69%,#89B3FE_95.6%)]
              dark:bg-[linear-gradient(143.42deg,#18FFB9_9.56%,#07B782_90.77%)]
            '
          >
            <div className='font-bold  bg-clip-text text-transparent bg-[linear-gradient(90deg,#FFFFFF_0%,#B5D0FF_100%)] dark:bg-[linear-gradient(90deg,#000000_0%,#005339_100%)] inline flex flex-col items-center justify-center h-full py-8'>
              <div className='text-[100px] md:text-[160px] leading-[100px] md:leading-[180px]'>{homeDetails?.deals_today}</div>
              <div className='text-[40px] leading-[40px]'>Heutige Pings</div>
            </div>
          </div>

          {/* Spy Search */}
          <Link to="/spySearch" className="block" aria-label="Spy Search">
            <Card withGradient>
              <SpySearch className='w-[45%] h-auto' />
              <div className='text-lg text-primary px-8 -mx-8 bg-custom-gradient-primary-light dark:bg-custom-gradient-primary-dark'>
                <strong>Spy</strong> Search
              </div>
            </Card>
          </Link>

          {/* A2A Flips */}
          <Link to="/a2aFlips" className="block" aria-label="A2A Flips">
            <Card withGradient>
              <A2AFlips className='w-[45%] h-auto' />
              <div className='text-lg text-primary px-8 -mx-8 bg-custom-gradient-primary-light dark:bg-custom-gradient-primary-dark'>
                <strong>A2A</strong> Flips
              </div>
            </Card>
          </Link>

          <div className={classNames(
            'col-span-2 row-span-3 xl:col-start-5',
            'rounded-[26px] flex',
            'xl:pt-[1px] xl:bg-[linear-gradient(90deg,#FFFFFF_0%,#639DFF_50%,#FFFFFF_100%)] xl:dark:bg-[linear-gradient(90deg,rgba(25,220,161,0)_0%,#43FFC6_47.5%,rgba(13,118,86,0)_100%)]',
          )}>
            <div className={classNames(
              'border-t-[1px] border-b-[1px] dark:border-[#43FFC610]',
              'flex-1 flex bg-background flex-col items-center justify-center shadow-[0px_0px_4px_0px_#0000001A] rounded-[26px] gap-4 py-6',
              'xl:bg-[linear-gradient(180deg,_rgba(99,157,255,0.1)_0%,_rgba(255,255,255,0)_100%)] xl:dark:bg-[linear-gradient(180deg,_rgba(30,242,178,0.1)_0%,_rgba(0,0,0,0)_45%)]',
            )}>
              <TodoList className='p-8' />
            </div>
          </div>

          {/* Preis Wecker */}
          <Link to="/preiswecker" className="block" aria-label="Preis Wecker">
            <Card>
              <PreisWecker className='w-[45%] h-auto' />
              <div className='text-lg text-primary px-8 -mx-8 bg-custom-gradient-primary-light dark:bg-custom-gradient-primary-dark'>
                <strong>Preis </strong> Wecker
              </div>
            </Card>
          </Link>

          {/* Scan Wizard */}
          <Link to="/wholesale" className="block" aria-label="Scan Wizard">
            <Card>
              <ScanWizard className='w-[45%] h-auto' />
              <div className='text-lg text-primary px-8 -mx-8 bg-custom-gradient-primary-light dark:bg-custom-gradient-primary-dark'>
                <strong>Scan</strong> Wizard
              </div>
            </Card>
          </Link>

          <Card className='col-span-2'>
            <div className='grid grid-cols-7 w-full text-sm sm:text-lg text-primary bg-custom-gradient-primary-light dark:bg-custom-gradient-primary-dark font-bold'>
              <div className='flex items-center justify-center col-span-3'>Dein Modul</div>
              <div className='flex items-center justify-center col-span-2'>Gesparte Zeit</div>
              <div className='flex items-center justify-center col-span-2'>Sourcing</div>
            </div>

            <div className='text-2xl grid grid-cols-7 w-full font-bold text-primary'>
              {homeDetails ? <>
                <div className='p-2 flex col-span-3 items-center justify-center capitalize bg-custom-gradient-primary-light dark:bg-custom-gradient-primary-dark'>
                  {homeDetails.most_used_module}
                </div>
                <div className='p-2 flex col-span-2 items-center justify-center bg-custom-gradient-primary-light dark:bg-custom-gradient-primary-dark'>
                  {homeDetails.saved_time}
                </div>
                <div className='p-2 flex col-span-2 items-center justify-center bg-custom-gradient-primary-light dark:bg-custom-gradient-primary-dark'>
                  {homeDetails.sourced_time}
                </div>
              </> : <Skeleton />
              }
            </div>
          </Card>
        </div>
      </div>
      </section>

      <CommonModal
        isOpen={showOnboardingVideo && isOnboardingModalOpen}
        closeModal={handleCloseOnboardingModal}
        overflowY={false}
        width="90vw"
        maxWidth="960px"
      >
        <div className='bg-background rounded-[12px] p-4 md:p-6 flex flex-col gap-4'>
          <div className='flex items-center justify-between gap-4'>
            <div>
            <p className='text-sm uppercase tracking-wide text-textPrimary'>Onboarding</p>
            <h2 className='text-2xl font-semibold text-textTitle'>Willkommen bei Edge</h2>
            </div>
            <button
              type="button"
              onClick={handleCloseOnboardingModal}
              className='w-10 h-10 rounded-full bg-primary/10 text-primary flex items-center justify-center hover:bg-primary/20 transition'
              aria-label="Onboarding Video schließen"
            >
              <i className="bx bx-x text-2xl"></i>
            </button>
          </div>

          <div className='relative w-full' style={{ paddingTop: '56.25%' }}>
            <iframe
              src="https://player.mediadelivery.net/embed/541164/6893c520-1626-421f-9069-a40b5b8028a9"
              title="Edge Onboarding Video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className='absolute top-0 left-0 w-full h-full rounded-xl'
            ></iframe>
          </div>
        </div>
      </CommonModal>
    </>
  )
}
